import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';
import  { GoogleAuthProvider }  from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyArU6OsU-m1GZQxT9W6WeDKuUqgBTb7Ujg",
  authDomain: "real-time-chat-app-5952a.firebaseapp.com",
  projectId: "real-time-chat-app-5952a",
  storageBucket: "real-time-chat-app-5952a.appspot.com",
  messagingSenderId: "677914972675",
  appId: "1:677914972675:web:19680d252326178741b436"
};

  const firebaseApp = firebase.initializeApp(firebaseConfig);
  const db = firebaseApp.firestore();
  const auth = firebase.auth();
  const provider = new GoogleAuthProvider();

  export { auth, provider, db};
 